export type Category = "全网" | "娱乐" | "科技" | "社会" | "财经" | "文体";

export interface Article {
  id: string;
  title: string;
  category: Exclude<Category, "全网">;
  tag: string;
  heat: number;
  source: string;
  time: string;
  views: string;
  summary: string;
  image: string;
  content: string[];
}

export interface RankGroup {
  key: string;
  label: string;
  color: string;
  dot: string;
}

export const categories: Category[] = ["全网", "娱乐", "科技", "社会", "财经", "文体"];

export const rankGroups: RankGroup[] = [
  { key: "全网", label: "全网热榜", color: "bg-primary-500", dot: "bg-primary-500" },
  { key: "娱乐", label: "娱乐瓜", color: "bg-accent-500", dot: "bg-accent-500" },
  { key: "科技", label: "科技瓜", color: "bg-secondary-500", dot: "bg-secondary-500" },
  { key: "社会", label: "社会瓜", color: "bg-foreground-900", dot: "bg-foreground-800" },
];

export const catStyle: Record<string, string> = {
  "娱乐": "bg-accent-100 text-accent-800",
  "科技": "bg-secondary-100 text-secondary-900",
  "社会": "bg-primary-100 text-primary-800",
  "财经": "bg-foreground-100 text-foreground-800",
  "文体": "bg-secondary-100 text-secondary-800",
};

export const newsTicker: string[] = [
  "今日 #内娱一瓜未平一瓜又起# 阅读量破 4 亿",
  "#硬核科技发布会# 新旗舰正式亮相",
  "#街头暖心一幕# 全城网友集体点赞",
  "#黄金价格再创新高# 年轻人开始囤金",
  "#国足新阵容官宣# 球迷直呼期待",
  "#全网都在跳的舞# 播放量一小时破千万",
];

export const feedArticles: Article[] = [
  {
    id: "f1",
    title: "某卫视年度古装大戏收官夜，主演团建照冲上热搜第一",
    category: "娱乐",
    tag: "热播剧",
    heat: 99,
    source: "卫视官微",
    time: "18 分钟前",
    views: "312 万",
    summary: "收官夜集体发长文告别角色，片方再曝幕后花絮，网友一边催番外一边期待下一部接档剧。",
    image: "https://readdy.ai/api/search-image?query=cinematic%20drama%20set%20with%20warm%20golden%20stage%20lights%20and%20elegant%20costume%20silhouette%2C%20editorial%20entertainment%20photography%2C%20soft%20bokeh%20backdrop%2C%20warm%20tonal%20palette&width=640&height=420&seq=feed-ent1&orientation=landscape",
    content: [
      "某卫视年度古装大戏在昨晚迎来收官夜。主演们先后在个人账号发布长篇告别文案，回忆拍摄期间的趣事，几度冲上热搜前几名。",
      "片方随后放出此前从未曝光的杀青花絮与幕后拍摄片段，其中两位主演的“临场改戏”名场面让弹幕瞬间刷屏，网友直呼“看哭了”。",
      "该剧编剧透露，番外篇已在筹备中，预计明年以特别篇形式上线。接档的古装新剧也同步官宣，被视为今年下半年的又一爆款候选。",
    ],
  },
  {
    id: "f2",
    title: "实力派歌手时隔四年发新专，首日预约量打破平台纪录",
    category: "娱乐",
    tag: "音乐",
    heat: 94,
    source: "音乐平台",
    time: "1 小时前",
    views: "208 万",
    summary: "十首原创曲目风格跨度极大，先行主打歌上线一小时播放破千万，乐评人给出罕见高分。",
    image: "https://readdy.ai/api/search-image?query=modern%20music%20studio%20with%20vinyl%20records%20and%20neon%20stage%20vibe%2C%20moody%20editorial%20lighting%2C%20musical%20energy%2C%20warm%20high%20contrast%20composition&width=640&height=420&seq=feed-ent2&orientation=landscape",
    content: [
      "沉淀四年的实力派歌手正式回归，全新专辑一次性上线十首原创曲目，涵盖摇滚、民谣与电子等多种风格，被乐迷称为“风格大冒险”。",
      "先行主打歌在上线一小时内播放量突破千万，平台预约人数刷新历史纪录。多位乐评人表示，这是近期完成度与概念性最强的一张作品。",
      "据经纪公司透露，专辑巡演已在规划中，首批开放的城市预售门票受到歌迷火热追捧。",
    ],
  },
  {
    id: "f3",
    title: "顶流新作票房逆跌登顶，导演一句话成全网金句",
    category: "娱乐",
    tag: "电影",
    heat: 90,
    source: "票务平台",
    time: "2 小时前",
    views: "186 万",
    summary: "口碑发酵带动排片上涨，单日票房不降反升实现逆跌，片尾彩蛋引发的讨论持续刷屏。",
    image: "https://readdy.ai/api/search-image?query=dramatic%20movie%20theater%20marquee%20with%20warm%20cinema%20glow%20and%20film%20poster%20mood%2C%20editorial%20cinematic%20photography%2C%20retro%20warm%20tones%2C%20soft%20light%20leak&width=640&height=420&seq=feed-ent3&orientation=landscape",
    content: [
      "新片上映第二日票房不降反升，成功实现“逆跌”登顶当日冠军，口碑效应显著带动了影院排片量。",
      "导演在路演现场回答观众提问时的一段话被剪辑成短视频全网转发，成为近期的爆款金句，相关话题阅读量已破数亿。",
      "片方宣布将开放点映加场，并透露片尾彩蛋里埋有续作线索，影迷已在逐帧寻找“隐藏菜单”。",
    ],
  },
  {
    id: "f4",
    title: "新一代旗舰芯片正式发布：能效提升显著，旗舰新机下月见",
    category: "科技",
    tag: "芯片",
    heat: 96,
    source: "发布会",
    time: "40 分钟前",
    views: "265 万",
    summary: "采用更先进制程工艺，综合能效较上代大幅提升，首批搭载的旗舰机型已开始预热。",
    image: "https://readdy.ai/api/search-image?query=futuristic%20microchip%20closeup%20on%20circuit%20board%20with%20golden%20and%20teal%20glow%2C%20high%20tech%20editorial%20photography%2C%20premium%20minimal%20composition%2C%20warm%20accent%20lighting&width=640&height=420&seq=feed-tech1&orientation=landscape",
    content: [
      "新一代旗舰芯片在今日发布会上正式亮相，官方数据显示其在相同功耗下综合性能与能效较上代均实现明显提升。",
      "该芯片重点优化了端侧 AI 计算能力与影像处理管线，预计将带动新一波旗舰机型升级潮。",
      "首批搭载该芯片的旗舰新机已同步开启预热，相关影像与游戏实测内容成为数码圈最新热议话题。",
    ],
  },
  {
    id: "f5",
    title: "国产操作系统生态大版本更新：原生应用数量翻倍增长",
    category: "科技",
    tag: "操作系统",
    heat: 88,
    source: "开发者社区",
    time: "3 小时前",
    views: "143 万",
    summary: "新版本强化跨设备协同与隐私能力，主流办公软件已完成深度适配，开发者反馈积极。",
    image: "https://readdy.ai/api/search-image?query=abstract%20digital%20ecosystem%20network%20with%20glowing%20nodes%20and%20connection%20lines%2C%20clean%20tech%20editorial%20art%2C%20soft%20gradient%20background%2C%20warm%20highlights&width=640&height=420&seq=feed-tech2&orientation=landscape",
    content: [
      "国产操作系统迎来生态大版本更新，重点强化了跨设备协同、数据流转与隐私保护能力，整体交互体验更加流畅统一。",
      "据官方统计，本次更新后完成原生适配的主流应用数量实现翻倍增长，办公、社交与影音场景覆盖明显提速。",
      "不少开发者反馈新版本开发工具链更友好，接口文档清晰，第三方应用的接入门槛进一步降低。",
    ],
  },
  {
    id: "f6",
    title: "AI 聊天工具新功能上线：可一键整理会议纪要并生成待办",
    category: "科技",
    tag: "人工智能",
    heat: 91,
    source: "应用商店",
    time: "5 小时前",
    views: "176 万",
    summary: "实测纪要结构化程度高，能自动提取关键结论与负责人，办公场景评价普遍不错。",
    image: "https://readdy.ai/api/search-image?query=modern%20minimal%20workspace%20desk%20with%20laptop%20and%20organized%20notes%20and%20coffee%2C%20clean%20bright%20editorial%20photography%2C%20warm%20natural%20light%2C%20productivity%20concept&width=640&height=420&seq=feed-tech3&orientation=landscape",
    content: [
      "主流 AI 聊天工具近期上线了新功能，能够自动整理会议录音并生成结构化纪要，还能同步拆解出可执行的待办事项。",
      "有用户实测反馈，该功能对关键结论与责任人的提取较为准确，交接与复盘效率提升明显，办公人群反响普遍积极。",
      "开发团队表示后续将支持自定义模板与团队知识库联动，进一步贴近企业真实协作场景。",
    ],
  },
  {
    id: "f7",
    title: "消防员火场救出被困老人，网友：这才是真正的偶像",
    category: "社会",
    tag: "正能量",
    heat: 97,
    source: "城市晚报",
    time: "30 分钟前",
    views: "423 万",
    summary: "浓烟中接力护送的画面被路人拍下，短时间内刷屏各大平台，评论区满是敬意与点赞。",
    image: "https://readdy.ai/api/search-image?query=firefighter%20in%20heroic%20silhouette%20carrying%20elderly%20person%20through%20smoke%2C%20dramatic%20warm%20lighting%2C%20editorial%20news%20photography%2C%20inspiring%20and%20emotional%20moment&width=640&height=420&seq=feed-soc1&orientation=landscape",
    content: [
      "某市一居民楼凌晨突发火情，消防员迅速抵达现场，并在浓烟中接力护送一名行动不便的老人安全转移。",
      "这暖心的一幕被路过的市民用手机拍下并上传网络，短时间内播放量突破千万，评论区满是敬意与点赞。",
      "当事消防员事后低调回应“这是职责所在”，网友却纷纷表示“这一刻的逆行者，才是最值得追的星”。",
    ],
  },
  {
    id: "f8",
    title: "热心店主十年免费送早餐给环卫工，本店成城市温暖地标",
    category: "社会",
    tag: "暖心",
    heat: 92,
    source: "本地媒体",
    time: "4 小时前",
    views: "198 万",
    summary: "十年如一日的清晨约定，让一家小早餐店成为全城热议的“温暖地标”，店主却笑称只是举手之劳。",
    image: "https://readdy.ai/api/search-image?query=cozy%20morning%20breakfast%20shop%20counter%20with%20steaming%20food%20and%20warm%20sunlight%2C%20street%20cleaner%20receiving%20warm%20meal%2C%20heartwarming%20editorial%20photography%2C%20soft%20warm%20tones&width=640&height=420&seq=feed-soc2&orientation=landscape",
    content: [
      "城市街角一家不起眼的早餐店，十年如一日为清晨清扫的环卫工免费准备早餐，这一约定从未间断。",
      "店主表示最初只是看大家清晨辛苦，于是顺手多备几份，没想到一坚持就是整整十年，如今早已把大家当成家人。",
      "故事经本地媒体与网友自发传播后，这家小店成为全城热议的“温暖地标”，不少市民专程赶来表达敬意。",
    ],
  },
  {
    id: "f9",
    title: "黄金价格再创新高，年轻群体开启“攒金豆”新模式",
    category: "财经",
    tag: "黄金",
    heat: 87,
    source: "财经媒体",
    time: "6 小时前",
    views: "155 万",
    summary: "金价高位之下，“攒金豆”式小额投资在年轻人中走红，多家金店门店预约排起长队。",
    image: "https://readdy.ai/api/search-image?query=elegant%20gold%20bars%20and%20small%20gold%20beans%20on%20soft%20cream%20background%2C%20luxury%20finance%20editorial%20photography%2C%20warm%20golden%20lighting%2C%20clean%20premium%20composition&width=640&height=420&seq=feed-fin1&orientation=landscape",
    content: [
      "国际金价持续走高并再度刷新纪录，与此同时，“攒金豆”式的小额实物金投资在年轻群体中迅速走红。",
      "多家金店门店的金豆与生肖金饰出现明显抢购，部分热门款式门店预约排起长队，线上销量也同步上涨。",
      "理财人士提醒，实物金更适合长期配置，需理性看待价格波动，避免跟风追高。",
    ],
  },
  {
    id: "f10",
    title: "国货老字号凭爆款产品“翻红”，线下门店排起长龙",
    category: "财经",
    tag: "消费",
    heat: 82,
    source: "商业周刊",
    time: "8 小时前",
    views: "109 万",
    summary: "老字号通过产品与营销双创新重回年轻人视野，热度带动线下门店营业额明显回升。",
    image: "https://readdy.ai/api/search-image?query=vintage%20chinese%20brand%20storefront%20with%20customers%20queueing%20and%20traditional%20product%20display%2C%20warm%20retail%20editorial%20photography%2C%20nostalgic%20yet%20fresh%20mood%2C%20soft%20daylight&width=640&height=420&seq=feed-fin2&orientation=landscape",
    content: [
      "一家拥有数十年历史的国货老字号，近期凭借一款口味与包装全面升级的爆款产品成功“翻红”，迅速回归年轻人视野。",
      "品牌通过短视频与联名持续制造话题，线下门店连续多日排起长龙，部分热卖单品一上架即被抢购一空。",
      "业内人士分析，老字号的“第二春”源于在守住品质底线的同时，真正读懂了新一代消费者的喜好与表达方式。",
    ],
  },
  {
    id: "f11",
    title: "全新国家队阵容官宣，年轻球员担纲核心引发期待",
    category: "文体",
    tag: "体育",
    heat: 89,
    source: "体育总局",
    time: "2 小时前",
    views: "204 万",
    summary: "新一期集训名单正式公布，多名年轻球员被寄予厚望，主帅谈目标时强调“敢于大胆轮换”。",
    image: "https://readdy.ai/api/search-image?query=dynamic%20football%20stadium%20at%20dusk%20with%20players%20in%20motion%20and%20crowd%20lights%2C%20energetic%20sports%20editorial%20photography%2C%20warm%20stadium%20glow%2C%20action%20frozen&width=640&height=420&seq=feed-spo1&orientation=landscape",
    content: [
      "全新一期国家队集训名单正式官宣，与以往不同，本次阵容注入大量年轻血液，多名潜力球员被提升至核心位置。",
      "主帅在发布会表示，阵容调整旨在加快队伍换血，让更多年轻人获得大赛历练机会，并强调会“敢于大胆轮换”。",
      "名单公布后迅速登上热搜，球迷普遍持积极态度，纷纷表示期待年轻一代在接下来比赛中的表现。",
    ],
  },
  {
    id: "f12",
    title: "围棋决赛五番棋激战：00 后小将破纪录捧杯创历史",
    category: "文体",
    tag: "棋牌",
    heat: 78,
    source: "棋院官微",
    time: "10 小时前",
    views: "88 万",
    summary: "关键一局长达六小时，小将在劣势下连续走出精妙妙手，逆转夺冠并刷新最年轻纪录。",
    image: "https://readdy.ai/api/search-image?query=elegant%20go%20board%20with%20black%20and%20white%20stones%20under%20warm%20table%20lamp%20light%2C%20serene%20strategic%20editorial%20photography%2C%20minimal%20warm%20tone%2C%20deep%20focus&width=640&height=420&seq=feed-spo2&orientation=landscape",
    content: [
      "围棋决赛第五局于昨夜分出胜负，一位 00 后小将在局面一度落后的情况下，连续走出精妙妙手实现逆转，最终捧起冠军奖杯。",
      "整盘关键对局耗时超过六个小时，观战人数与话题热度均创下近年之最，解说直呼“看到了未来棋坛的模样”。",
      "赛后小将低调表示夺冠只是新的起点，接下来的世界大赛才是真正的试金石。",
    ],
  },
  {
    id: "f13",
    title: "热播剧衍生综艺官宣，原班人马回归加码“售后”",
    category: "娱乐",
    tag: "综艺",
    heat: 85,
    source: "卫视官微",
    time: "1 小时前",
    views: "167 万",
    summary: "热播剧收官后的首个衍生综艺正式官宣，主演原班人马集结，被剧迷称为“最强售后”。",
    image: "https://readdy.ai/api/search-image?query=bright%20variety%20show%20studio%20with%20colorful%20set%20and%20warm%20lively%20lighting%2C%20playful%20entertainment%20editorial%20photography%2C%20cheerful%20energetic%20mood%2C%20candid%20backstage&width=640&height=420&seq=feed-ent4&orientation=landscape",
    content: [
      "此前大热的古装剧在收官数周后再度引爆话题——其衍生旅行综艺正式官宣，原班主演人马将全部回归。",
      "据悉节目将聚焦剧组伙伴重聚，以“老友同行”的形式呈现，被剧迷们戏称为最强售后与心愿清单。",
      "官宣片花一经释出便冲上热搜，评论区已被“立刻抬上来”的呼声刷屏，播出档期同样备受关注。",
    ],
  },
  {
    id: "f14",
    title: "短剧市场持续升温：精品化成大势，破圈作品频出",
    category: "娱乐",
    tag: "短剧",
    heat: 76,
    source: "行业观察",
    time: "12 小时前",
    views: "95 万",
    summary: "短剧创作加速精品化，一批剧本扎实、制作精良的作品频繁破圈，商业模式也在快速成熟。",
    image: "https://readdy.ai/api/search-image?query=phone%20screen%20with%20glowing%20short%20video%20content%20on%20warm%20cozy%20desk%2C%20modern%20entertainment%20editorial%20photography%2C%20soft%20bokeh%20background%2C%20trending%20media%20concept&width=640&height=420&seq=feed-ent5&orientation=landscape",
    content: [
      "随着行业竞争加剧，短剧正从“量大管饱”加速走向精品化，剧本、制作与表演的投入水涨船高。",
      "近期多部制作精良的短剧频繁破圈，不仅播放量屡创新高，还带动了相关原著与周边话题的热度。",
      "分析认为，精品化让短剧逐步摆脱“快餐”标签，商业模式也随之成熟，成为内容行业不可忽视的新力量。",
    ],
  },
  {
    id: "f15",
    title: "城市晚霞刷屏朋友圈：气象局回应称今天云层很“给力”",
    category: "社会",
    tag: "天气",
    heat: 74,
    source: "气象微博",
    time: "2 小时前",
    views: "132 万",
    summary: "傍晚绝美晚霞刷屏社交平台，气象部门幽默回应，并提醒早晚温差较大注意添衣。",
    image: "https://readdy.ai/api/search-image?query=stunning%20orange%20and%20rose%20sunset%20clouds%20over%20city%20skyline%2C%20golden%20hour%20sky%2C%20breathtaking%20editorial%20landscape%20photography%2C%20warm%20romantic%20mood&width=640&height=420&seq=feed-soc3&orientation=landscape",
    content: [
      "今天傍晚，绝美的晚霞刷屏了无数人的朋友圈与社交平台，天空呈现出罕见的橙粉渐变，宛如油画一般。",
      "面对网友“晚霞预报”的调侃，当地气象部门幽默回应称“今天的云层十分给力”，并顺势发布未来几天的天气趋势。",
      "气象部门也暖心提醒，近期昼夜温差明显加大，早出晚归的市民要注意适时添衣，谨防着凉。",
    ],
  },
  {
    id: "f16",
    title: "地铁车厢上演暖心接力：全车厢齐力扶起跌倒乘客",
    category: "社会",
    tag: "暖心",
    heat: 80,
    source: "城市日报",
    time: "7 小时前",
    views: "121 万",
    summary: "列车进站瞬间乘客意外摔倒，多名市民与站务员几乎同时上前搀扶，画面温暖无数网友。",
    image: "https://readdy.ai/api/search-image?query=inside%20modern%20city%20subway%20carriage%20with%20warm%20interior%20lighting%20and%20passengers%20helping%2C%20kind%20urban%20moment%2C%20editorial%20documentary%20photography%2C%20warm%20human%20touch&width=640&height=420&seq=feed-soc4&orientation=landscape",
    content: [
      "地铁列车在进站瞬间，一名乘客因重心不稳在车厢内跌倒，周围多名乘客与站务员几乎同时起身上前搀扶。",
      "这短短的几秒钟被监控与乘客手机完整记录，接力扶人的画面温暖了无数网友，相关话题迅速登上热搜。",
      "有网友留言表示“这一刻的善意与默契，就是一座城市最动人的底色”。",
    ],
  },
  {
    id: "f17",
    title: "车企价格战再起：多品牌官宣限时优惠，消费者观望情绪升温",
    category: "财经",
    tag: "汽车",
    heat: 83,
    source: "行业媒体",
    time: "5 小时前",
    views: "134 万",
    summary: "多家新能源车企集中推出限时优惠与保价承诺，市场关注度骤升，但部分消费者仍在等待更低点。",
    image: "https://readdy.ai/api/search-image?query=showroom%20of%20new%20electric%20vehicles%20with%20glossy%20curved%20body%20under%20warm%20spotlights%2C%20premium%20automotive%20editorial%20photography%2C%20modern%20clean%20composition&width=640&height=420&seq=feed-fin3&orientation=landscape",
    content: [
      "进入本周，多家新能源车企不约而同官宣限时购车优惠，并配套推出保价承诺，汽车市场的价格战再度升温。",
      "优惠信息迅速提振了终端到店量，不过也有相当一部分消费者选择继续观望，希望等到更合适的价格节点。",
      "业内人士提醒，价格波动属市场常态，购车更应结合自身用车需求理性决策，切勿只盯着账面优惠。",
    ],
  },
  {
    id: "f18",
    title: "全民健身新时尚：城市夜跑团迅速壮大，成街头亮丽风景",
    category: "文体",
    tag: "健身",
    heat: 71,
    source: "健康频道",
    time: "9 小时前",
    views: "79 万",
    summary: "天气转凉催热夜跑风潮，各大城市夜跑团迅速壮大，运动装备与健康话题同步升温。",
    image: "https://readdy.ai/api/search-image?query=runners%20jogging%20together%20along%20urban%20riverside%20at%20blue%20hour%20with%20city%20lights%2C%20fitness%20community%20mood%2C%20editorial%20lifestyle%20photography%2C%20cool%20yet%20warm%20accents&width=640&height=420&seq=feed-spo3&orientation=landscape",
    content: [
      "随着天气转凉，各大城市的夜跑族悄然壮大，风格各异的夜跑团成为街头一道亮丽的风景线。",
      "不少跑团通过打卡与社群把跑步玩出了新花样，既锻炼了身体，也结交了同好，运动热潮带动相关装备销量同步升温。",
      "健康专家提醒，夜跑要循序渐进、量力而行，并注意交通安全与防寒保暖，才能真正跑出健康与快乐。",
    ],
  },
];

export const featuredArticles: Article[] = [
  feedArticles[0],
  feedArticles[6],
  feedArticles[3],
];

export const timeline: { time: string; title: string; category: string; summary: string }[] = [
  { time: "09:12", title: "某卫视古装剧收官夜花絮释出，登顶热搜第一", category: "娱乐", summary: "片方连更九宫格花絮，主演集体发文告别角色。" },
  { time: "10:40", title: "新一代旗舰芯片正式发布", category: "科技", summary: "能效大幅提升，首批旗舰机开启预热。" },
  { time: "11:30", title: "消防员火场接力救人画面刷屏", category: "社会", summary: "暖心一幕播放量快速突破千万。" },
  { time: "13:20", title: "黄金价格刷新纪录，年轻人加入囤金潮", category: "财经", summary: "金豆与生肖金饰门店排起长队。" },
  { time: "15:05", title: "实力派歌手新专上线，预约量创纪录", category: "娱乐", summary: "十首曲目风格跨度大，乐评高分。" },
  { time: "17:40", title: "国家队新一期集训名单官宣", category: "文体", summary: "多名年轻球员获重用，球迷期待满满。" },
  { time: "19:15", title: "城市绝美晚霞刷屏朋友圈", category: "社会", summary: "气象部门幽默回应云层“很给力”。" },
];

export const faqs: { q: string; a: string }[] = [
  {
    q: "吃瓜网上多久更新一次？",
    a: "我们的内容会全天候滚动更新，早中晚各有一次重点汇总。遇到突发热点或大型事件，会实时追更并第一时间在热榜置顶，让你随时点进来都能看到最新鲜的瓜，不需要到处翻。",
  },
  {
    q: "网站上的热点信息来源可靠吗？",
    a: "我们汇总的内容均整理自公开的媒体报道、官方账号声明与主流平台的话题数据，并会尽量标注出处与时间。页面呈现的是全网公开讨论的综合梳理，帮助你在最短时间内了解事件脉络。",
  },
  {
    q: "吃瓜网上收费吗？需要注册吗？",
    a: "完全免费，也不需要注册登录。为了照顾不同读者的习惯，我们暂时不设会员与付费墙，打开页面即可浏览全部热点与分类内容，把阅读门槛降到最低。",
  },
  {
    q: "发现某条内容有误或与事实不符怎么办？",
    a: "我们非常重视内容的准确度。如果你发现某条信息存在偏差，可以通过页面底部的联系方式告诉我们，并附上权威信源链接。核实无误后，我们会第一时间修正或下架相关内容。",
  },
  {
    q: "如何向我们投稿或提供独家线索？",
    a: "欢迎通过页面底部的邮箱与我们联系，请尽量提供时间、地点、人物等基础信息以及可查证的来源。所有投稿我们都会认真阅读，一经采用会标注来源并对信息进行二次核实。",
  },
];